import React from 'react'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Radio from '@material-ui/core/Radio'
import Grid from '@material-ui/core/Grid'
import Utils from 'EurestoFonction/Utils'

export default class Index extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      contactModalOpen: false,
      indexContactSelect: -1,
      addNewContact: -1,
      modalKey: Utils.getRandomNumber(),
      key: Utils.getRandomNumber(),
      data: props.data
    }
  }

  handleChange = (add, id) => {
    let data = this.props.data
    const i = data.indexOf(id)
    if (i === -1) {
      if (add) {
        data.push(id)
      }
    } else {
      if (!add) {
        data.splice(i, 1)
      }
    }

    this.props.onChange(data, this.props.type)
  }

  render () {
    const relation = Data.list(Constants.module.CONFIGURATION, Constants.donnee.etablissement)
    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'} alignItems={'flex-start'}>
        {
          relation.map((e, i) =>
            (
              <Grid item style={{ margin: 0, padding: 0 }} xs={4} key={'gridER-' + i}>
                <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'flex-start'}
                      alignItems={'flex-start'}>
                  <Grid item style={{ margin: 0, padding: 0, textAlign: 'left', paddingLeft: 10 }} xs={12}>
                    <label style={{ textAlign: 'left' }}>{e.libelle}</label>
                  </Grid>
                  <Grid item style={{ margin: 0, padding: 0, textAlign: 'left', paddingLeft: 10 }} xs={12}>
                    <Radio
                      checked={this.props.data.indexOf(e.id) !== -1}
                      onChange={() => this.handleChange(true, e.id)}
                      value="a"
                      name="radio-button-demo"
                      disabled={this.props.disabled || false}
                      aria-label="A"
                    />Oui
                    <Radio
                      checked={this.props.data.indexOf(e.id) === -1}
                      onChange={() => this.handleChange(false, e.id)}
                      value="a"
                      name="radio-button-demo"
                      disabled={this.props.disabled || false}
                      aria-label="A"
                    />Non
                  </Grid>
                </Grid>
              </Grid>
            )
          )
        }
      </Grid>
    )
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Relations/index.js